import { Injectable } from '@angular/core';
import { NavigationError } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ErrorLoggerService {
  error(error: NavigationError) {
    console.error(error);
  }
}
